'use client';
import React from 'react';
import get from 'lodash/get';
import CategoryNewsBlockHome from './CategoryNewsBlockHome';

const ActivityOther = ({ postsByShowcaseWalls, websiteCode, deviceType }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5 pb-5">
      {get(postsByShowcaseWalls, 'results', [])
        .slice(0, 4)
        .map((item) => (
          <CategoryNewsBlockHome key={item.slug} item={item} slug="tin-tuc" websiteCode={websiteCode} deviceType={deviceType} />
        ))}
    </div>
  );
};

export default ActivityOther;
